import { createAsyncThunk } from "@reduxjs/toolkit";
import { specificationFolderService } from "@/shared/services/api/specification-folder-services";
import {
  ISpecificationFolderGetRequest,
  ISpecificationFolderDetailGetRequest,
  ISpecificationFolderUpdateRequest,
  ISpecificationFolderMoveRequest,
  ISpecificationFolderOrderRequest,
} from "@/shared/services/interface/requests/ISpecificationFolderRequest";
import { RootState } from "../store";

export const getSpecificationFoldersThunk = createAsyncThunk(
  "specificationFolder/getSpecificationFolders",
  async (data: ISpecificationFolderGetRequest, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const { column, direction } = state.specificationList.sort;
    if (!data.sortBy) {
      data.sortBy = `${column}:${direction}`;
    }
    try {
      const response = await specificationFolderService.getSpecificationFolders(
        data
      );
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.message || "Klasörler getirilemedi"
      );
    }
  }
);

export const getSpecificationFoldersThunkNoReload = createAsyncThunk(
  "specificationFolder/getSpecificationFoldersNoReload",
  async (data: ISpecificationFolderGetRequest, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const { column, direction } = state.specificationList.sort;
    if (!data.sortBy) {
      data.sortBy = `${column}:${direction}`;
    }
    try {
      const response = await specificationFolderService.getSpecificationFolders(
        data
      );
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.message || "Klasörler getirilemedi"
      );
    }
  }
);

export const getSpecificationFolderDetailThunk = createAsyncThunk(
  "specificationFolder/getSpecificationFolderDetail",
  async (data: ISpecificationFolderDetailGetRequest, thunkAPI) => {
    try {
      const response =
        await specificationFolderService.getSpecificationFolderDetail(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.message || "Klasör detayı getirilemedi"
      );
    }
  }
);
// to delete
export const updateSpecificationFolderThunk = createAsyncThunk(
  "specificationFolder/updateSpecificationFolder",
  async (data: ISpecificationFolderUpdateRequest, thunkAPI) => {
    try {
      const response =
        await specificationFolderService.updateSpecificationFolder(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.message || "Klasör güncellenemedi"
      );
    }
  }
);

export const moveSpecificationFolderThunk = createAsyncThunk(
  "specificationFolder/moveSpecificationFolder",
  async (data: ISpecificationFolderMoveRequest, thunkAPI) => {
    try {
      const response = await specificationFolderService.moveSpecificationFolder(
        data
      );
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "Klasör taşınamadı");
    }
  }
);

export const updateSpecificationFolderOrderThunk = createAsyncThunk(
  "specificationFolder/updateSpecificationFolderOrder",
  async (data: ISpecificationFolderOrderRequest, thunkAPI) => {
    try {
      const response =
        await specificationFolderService.updateSpecificationFolderOrder(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.message || "Klasör sıralaması güncellenemedi"
      );
    }
  }
);
